
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import get from 'lodash/get';

import { getToken } from '../../reducers/auth';
import { getActualCategoryName, getCategoryData } from '../../reducers/category';
import { getProjectId } from '../../reducers/project';
import { getSelection } from '../../reducers/selection';

import categoryGetActions from '../../sagas/category';
import exportDataGetActions from '../../sagas/exportData';
import searchGetActions from '../../sagas/search';

import DialogClustersInfo from './DialogClustersInfo';

const ToolsButton = (props) => {

    const dispatch = useDispatch();
    const categoryActions = categoryGetActions(dispatch);
    const exportDataActions = exportDataGetActions(dispatch);
    const searchActions = searchGetActions(dispatch);

    const token = useSelector(state => getToken(state));
    const projectId = useSelector(state => getProjectId(state));
    const actualCategoryName = useSelector(state => getActualCategoryName(state));
    const categoryData = useSelector(state => getCategoryData(state.category));
    const selection = useSelector(state => getSelection(state.selection));
    const actualList = useSelector(state => {
        return state.list.actualList;
    });

    React.useEffect(() => {
        async function func() {
            let clustersData = get(categoryData, 'result.clustersData');
            if (clustersData) {
                await DialogClustersInfo.show(
                    clustersData,
                    handleExportClustersCsv,
                    handleExportClustersGeoJson
                );
            }
        }
        func();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoryData]);

    const handleExportClustersCsv = () => {
        exportDataActions.exportClustersCsv(token, projectId, actualCategoryName);
    }

    const handleExportClustersGeoJson = () => {
        exportDataActions.exportClustersGeoJson(token, projectId, actualCategoryName);
    }

    const handleGenerateClusters = () => {
        categoryActions.generateClusters(token, projectId, actualList.name, actualCategoryName);
    }

    const handleSearchParcel = () => {
        searchActions.openSearch('PAR');
    }

    const handleSearchVlastnik = () => {
        searchActions.openSearch('VLA');
    }

    const handleExportParcCsv = () => {
        exportDataActions.exportParcCsv(token, projectId, actualCategoryName, false);
    }

    const handleExportParcGeoJson = () => {
        exportDataActions.exportParcGeoJson(token, projectId, actualCategoryName);
    }

    const handleExportParcCsvSelected = () => {
        exportDataActions.exportParcCsv(token, projectId, actualCategoryName, true);
    }

    return (
        <Stack horizontal horizontaAlign="end">
            <Stack.Item grow>
                <div></div>
            </Stack.Item>
            <Stack.Item>
                <DefaultButton
                    text="Další nástroje"
                    menuProps={{
                        items: [{
                            key: "searchPar",
                            text: "Vyhledat parcely",
                            title: "Zobrazit panel pro vyhledávání parcel",
                            onClick: handleSearchParcel
                        }, {
                            key: "searchVla",
                            text: "Vyhledat vlastníky",
                            title: "Zobrazit panel pro vyhledávání vlastníků",
                            onClick: handleSearchVlastnik
                        }, {
                            key: "generateClusters",
                            text: "Vygenerovat souvislosti",
                            title: "Vygenerovat souvislosti parcel pro aktuální kategorii",
                            onClick: handleGenerateClusters
                        }, {
                            key: "exportParcCsv",
                            text: "Export všech parcel do CSV",
                            title: "Export všech parcel v aktuální kategorii do CSV",
                            onClick: handleExportParcCsv
                        }, {
                            key: "exportParcGeoJson",
                            text: "Export všech parcel do GeoJSON",
                            title: "Export všech parcel v aktuální kategorii do GeoJSON",
                            onClick: handleExportParcGeoJson
                        }, {
                            key: "exportParcCsvSelected",
                            text: "Export vybraných parcel do CSV",
                            title: "Export vybraných parcel v aktuální kategorii do CSV",
                            disabled: (selection.count === 0),
                            onClick: handleExportParcCsvSelected
                        }]
                    }}
                />
            </Stack.Item>
        </Stack>
    );
}

export default ToolsButton;
